/* eslint-disable import/prefer-default-export */
export const UNEXPECTED_LOGIN_ERROR = 'common/unexpectedLoginError';
export const PRODIGAL_LOGO_DARK =
  'https://public.prodigaltech.com/prodigal-logo-dark.svg';
export const PRODIGAL_LOGO_LIGHT =
  'https://public.prodigaltech.com/prodigal-logo-light.svg';
